import React from 'react';
import styles from './index.module.scss';
import { formatBoldTextHTML } from '../../../../utils/formatBoldText';

const DescriptionComponent = ({
  contentData,
  contentText,
  contentName,
  imgName,
  imgsNames,
  videoName,
  compact = false,
}) => {
  if (compact && contentText && contentText !== 'none') {
    return (
      <div className={styles.compact}>
        <p dangerouslySetInnerHTML={{ __html: formatBoldTextHTML(contentText) }} />
      </div>
    );
  }
  return (
    <div className={styles.descriptionComponent}>
      <h2 className={styles.title}>Компонент Описания</h2>
      <p className={styles.description}>Компонент для отображения длинных описаний</p>
      {contentText && contentText !== 'none' && (
        <div className={styles.contentText}>
          <p dangerouslySetInnerHTML={{ __html: formatBoldTextHTML(contentText) }} />
        </div>
      )}
    </div>
  );
};

export default DescriptionComponent;
